import React from "react";

// eslint-disable-next-line no-unused-vars
import CircularProgress from "@material-ui/core/CircularProgress";
import ExcelIcon from "mdi-material-ui/FileExcel";

//jaza-soft
import { MuiTable } from "@jazasoft/mui-table";

import useScheduledTask from "./useScheduledTask";
import { useMutation } from "../../hooks";

const footerActions = [
  {
    name: "download",
    tooltip: "Download",
    icon: <ExcelIcon />,
    options: { variant: "outlined", style: { margin: "0.5em", color: "green", borderColor: "green" } }
  }
];

const ScheduledTaskHistory = ({ tabIdx, period }) => {
  const { columns, rows } = useScheduledTask({ period, page: "history" });

  const [download] = useMutation({ rawResponse: true });

  const onFooterActionClick = (event, action, rows, filterValues, onActionComplete) => {
    if (action === "download") {
      const filename = `TASKS.xlsx`;

      const columnList = columns.map(c => ({ ...c, type: c.dataKey === "createdAt" ? "date" : undefined }));
      const rowList = rows.map((row, idx) => ({
        rowNo: idx + 1,
        cellList: columnList.map(c => ({ dataKey: c.dataKey, value: row[c.dataKey] }))
      }));

      const options = {
        url: `export/excel`,
        method: "post",
        responseType: "arraybuffer",
        params: { filename },
        data: [{ sheetNo: 0, autoSizeColumn: true, sheetName: "ROLLS", excelData: { columnList, rowList } }]
      };

      download(options, {
        onSuccess: response => {
          if (response.status === 200) {
            const header = response.headers["content-disposition"];
            var fileName = header ? header.match(/filename="(.+)"/)[1] : `${filename}.xlsx`;

            let blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
          }
          onActionComplete && onActionComplete(rows);
        }
      });
    }
  };

  if (tabIdx !== 1) return null;

  return (
    <div>
      <MuiTable
        columns={columns}
        rows={rows}
        title="Tasks"
        fontSize={15}
        pageable
        searchable
        sortable
        comparator={(a, b) => b.id - a.id}
        searchKeys={["poRef"]}
        footerActions={footerActions}
        onFooterActionClick={onFooterActionClick}
      />
    </div>
  );
};

export default ScheduledTaskHistory;
